import { v4 as uuidv4 } from 'uuid';
import { images } from '../../constants';

const kidist = {
  id: uuidv4(),
  images: images.kidist,
  name: 'Kidist Guta',
  review: 'I rarely came across real talents who stand out like Collins. I had a pleasure of working together with Collins while at Microverse. His understanding of software engineering makes collaboration with him a delightful experience. We worked together on a variety of complex projects and I can confess his problem-solving approach is outstanding. I enthusiastically recommend him.',
  location: 'Addis Ababa, Ethiopia',
};
const naomi = {
  id: uuidv4(),
  images: images.yomie,
  name: 'Naomi Nafula',
  review: 'Collins is a highly skilled full-stack developer. He demonstrated exceptional proficiency in crafting a web application for our start-up company utilizing Ruby on Rails for the backend and React with Redux for the frontend. He is not only reliable, but also readily available to offer assistance whenever needed. His dedication is commendable 100%.',
  location: 'Nairobi, Kenya',
};
const reggie = {
  id: uuidv4(),
  images: images.reggie,
  name: 'Nonhlanhla (Reggie) Mndebele',
  review: 'Collins and I have been coding partners working on different projects for a while. I can say that he is a very dedicated individual and he is always willing to help, he is professional but mostly he is passionate about his work. We shared ideas on approaching project development and happened he is someone who understands what he does. I recommend him 100%.',
  location: 'Johannesburg, South Africa',
};
const aquinas = {
  id: uuidv4(),
  images: images.moriasi,
  name: 'Aquinas Moriasi',
  review: 'I had the pleasure of working with Collins to solve challenges and build software and I highly recommend him for any project or team. His technical skills are matched by his ability to effectively communicate and collaborate with others. I believe he would be an excellent addition to any organization.',
  location: 'Nairobi, Kenya',
};
const joash = {
  id: uuidv4(),
  images: images.joe,
  name: 'Joash Asewe',
  review: 'Collins is a great dev, fun to work with, and sharp with code debugging. While working with him at Symphony on an e-payment platform project, he helped teammates solve their back-end and front-end bugs. He is a good collaborator with solid problem-solving techniques. I vouch for him 101%!',
  location: 'Nairobi, Kenya',
};
const tarek = {
  id: uuidv4(),
  images: images.tarek,
  name: 'Tarek Yosry',
  review: 'Collins is someone who is not afraid to open up and leave his comfort zone to accomplish any task. It is so admirable, I worked with Collins for a week in Microverse as a coding partner and it was the best week I have had till now. In case of need for a skilled developer, I recommend him.',
  location: 'Cairo, Egypt',
};

const allTestimonialsData = [kidist, naomi, reggie, aquinas, joash, tarek];

export default allTestimonialsData;
